module.exports = __webpack_public_path__ + "static/media/gcdef_10031.675952ba.ico";